import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
 
import {shopifyApi, LATEST_API_VERSION} from '@shopify/shopify-api';
 
@Injectable({
  providedIn: 'root',
})
 
export class ShopifyService {
  public shopifyLoaded: boolean = false;
  constructor(private http: HttpClient) {};
 

  async getProducts(){
    let apiKey: '514a97801c553339853e797f8553a72b';
    let apiSecretKey: '32181321e746afa1ab6b409a2d79dac1';
    let storeUrl = 'https://65eefb-2.myshopify.com';
    
    fetch(`${storeUrl}/admin/api/2021-07/products.json`, {
      method: 'GET',
      headers: {
        'Authorization': `Basic ${btoa(`${apiKey}:${apiSecretKey}`)}`,
      },
    })
    .then(response => response.json())
    .then(data => {
      // Process and display the product data on your website
      console.log(data);
    })
    .catch(error => {
      console.error('Error fetching product data:', error);
    });

}
}


